import { bgColorForStep } from "~/components/Playground/Node/colors";
import { JobPillLink } from "~/components/build/Show/components/StepDrawer/JobPillLink";
import {
  useBuild,
  useMostRecentParallelJobsForStep,
} from "~/components/build/Show/lib/BuildContext";
import { sortJobsByState } from "~/components/build/Show/lib/sortJobsByState";
import { resolveStepUrl } from "~/components/build/Show/lib/urlForView";
import useCurrentJobOrStep from "~/components/build/Show/lib/useCurrentJobOrStep";
import { CommandStep } from "~/lib/pipeline";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { useStepDependencies } from "~/components/build/Show/lib/useStepDependencies";

/**
 * Render a subset of parallel jobs for a command step
 */
export const ParallelJobs = ({ step, limit = 5 }: { step: CommandStep; limit?: number }) => {
  const { missingDependencies } = useStepDependencies(step.uuid);

  const { build } = useBuild();
  const jobs = useMostRecentParallelJobsForStep(step.uuid);
  const { currentJob } = useCurrentJobOrStep();

  const sorted = [...jobs].sort(sortJobsByState("asc"));

  const filtered = sorted.slice(0, limit);
  if (filtered.length === 0) {
    return null;
  }

  return (
    <div
      // eslint-disable-next-line id-length
      onClick={(e) => e.stopPropagation()}
      className={twMerge(
        "text-charcoal-700 -mx-3 -mb-3 flex cursor-default flex-row flex-wrap gap-1.5 border-t px-3 pb-3 pt-3",
        bgColorForStep(step, missingDependencies, build),
      )}
    >
      {filtered.map((job) => {
        const index = job.parallelGroupIndex || 0;
        return (
          <JobPillLink
            job={job}
            key={job.id}
            className={classNames("text-charcoal-700 gap-1.5 bg-white", {
              "ring-4 ring-[#086DD7] ring-offset-1": job.id === currentJob?.id,
            })}
          >
            <span className="tabular-nums">{index + 1}</span>
          </JobPillLink>
        );
      })}
      {filtered.length < sorted.length && (
        <Link
          title="View all jobs"
          to={resolveStepUrl(step.uuid)}
          className="flex items-center gap-1.5 rounded-md border border-slate-500 bg-white px-3 py-1.5 text-xs text-inherit no-underline hover:text-inherit hover:no-underline focus:no-underline active:text-inherit active:shadow-inner"
        >
          ...
        </Link>
      )}
    </div>
  );
};
